// src/components/NavbarResponsive.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function NavbarResponsive({ onSignOut, isAdmin, user }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const navigate = useNavigate(); 
    
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const handleNavigate = (path) => {
        navigate(path);
        setIsMenuOpen(false); // Cierra el menú después de navegar
    };
    
    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    
    const handleSignOutAndClose = () => {
        onSignOut();
        setIsMenuOpen(false);
    };

    const isDesktop = width > 768;

    // Estilos Base
    const navStyle = {
        backgroundColor: '#007bff',
        padding: '15px 20px',
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative', // Necesario para el menú desplegable absoluto
    };
    const logoStyle = {
        fontSize: '18px', 
        fontWeight: 'bold', 
        cursor: 'pointer'
    };
    
    const desktopMenuContainerStyle = {
        display: isDesktop ? 'flex' : 'none', 
        gap: '20px',
        alignItems: 'center',
    };

    const desktopLinkStyle = {
        color: 'white',
        textDecoration: 'none',
        fontSize: '16px',
        padding: '5px 10px',
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
    };

    // Estilo especial para resaltar Caracas
    const caracasButtonStyle = {
        ...desktopLinkStyle,
        border: '1px solid white',
        borderRadius: '5px',
        fontWeight: 'bold'
    };

    const menuIconStyle = {
        fontSize: '30px',
        cursor: 'pointer',
        display: isDesktop ? 'none' : 'block', 
    };

    const dropdownMenuStyle = {
        position: 'absolute',
        top: '55px', 
        right: '0',
        width: '100%',
        backgroundColor: '#007bff',
        zIndex: 10,
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        display: (isMenuOpen && !isDesktop) ? 'block' : 'none',
    };

    const menuButtonStyle = {
        display: 'block',
        width: '100%',
        padding: '15px 20px',
        textAlign: 'left',
        backgroundColor: 'transparent',
        border: 'none',
        borderTop: '1px solid #0056b3',
        color: 'white',
        fontSize: '16px',
        cursor: 'pointer',
    };

    const actionButtonStyle = {
        ...menuButtonStyle,
        backgroundColor: '#f1c40f', 
        color: '#333',
        fontWeight: 'bold',
    };

    return (
        <header>
            <nav style={navStyle}>
                {/* Logo/Home */}
                <span onClick={() => handleNavigate('/')} style={logoStyle}>
                    Vimcar Broker
                </span>
                
                {/* MENÚ DE ESCRITORIO */}
                <div style={desktopMenuContainerStyle}>
                    <button onClick={() => handleNavigate('/catalogo')} style={desktopLinkStyle}>Miami / USA</button>
                    
                    {/* BOTÓN CARACAS AÑADIDO */}
                    <button onClick={() => handleNavigate('/vehiculo/frontlander-2025-ccs')} style={caracasButtonStyle}>
                        Caracas
                    </button>
                    
                    {/* 🛑 LÓGICA DE ADMIN: Solo visible si el usuario está logueado. 🛑 */}
                    {user ? (
                        <>
                            {/* Solo mostrar "Panel Admin" si el usuario logueado es isAdmin */}
                            {isAdmin && <button onClick={() => handleNavigate('/admin')} style={desktopLinkStyle}>Panel Admin</button>}
                            
                            <button onClick={onSignOut} style={{...desktopLinkStyle, color: '#f1c40f', fontWeight: 'bold'}}>
                                Cerrar Sesión
                            </button>
                        </>
                    ) : (
                        null
                    )}
                </div>

                {/* Ícono de Hamburguesa (Solo en móvil) */}
                <div onClick={toggleMenu} style={menuIconStyle}>
                    ☰
                </div>
            </nav>

            {/* Menú Desplegable (SOLO MÓVIL) */}
            <div style={dropdownMenuStyle}>
                <button onClick={() => handleNavigate('/catalogo')} style={menuButtonStyle}>Catálogo Miami</button>
                
                {/* BOTÓN CARACAS MÓVIL AÑADIDO */}
                <button onClick={() => handleNavigate('/vehiculo/frontlander-2025-ccs')} style={menuButtonStyle}>
                    Caracas (Entrega Inmediata)
                </button>
                
                {/* 🛑 LÓGICA DE ADMIN EN MÓVIL: Solo visible si el usuario está logueado. 🛑 */}
                {user ? (
                    <>
                        {isAdmin && <button onClick={() => handleNavigate('/admin')} style={menuButtonStyle}>Panel Admin</button>}

                        <button onClick={handleSignOutAndClose} style={actionButtonStyle}>
                            Cerrar Sesión
                        </button>
                    </>
                ) : (
                    null
                )}
            </div>
        </header>
    );
}

export default NavbarResponsive;